import axios from "axios";
import config from "../../settings/config";

async function map(params) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        `${config.baseUrl}v1/map/search?lat=${params.lat}&lng=${params.lng}&term=${params.term}`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {})
  );
}

export { map };
